import request from '@/utils/request'

export function orderBatch(type,data) {
  return request({
    url: 'api/yumiOrderBatch/'+type,
    method: 'post',
    data
  })
}
export function supplierEdit(data) {
  return request({
    url: 'api/yumiOrderSupplier',
    method: 'put',
    data
  })
}